import { useSelector } from "react-redux";
import TaskManagement from "../TaskManagement"
let isHomeCareCheck
const MenuList = () => {
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    isHomeCareCheck = DropDowns.IsHomeCare
    return [
        {
            name: 'Task',
            key: 786,
            icon: "",
            right: true,
            subCategoryItems: [
                {
                    name: 'All Tasks',
                    key: 7861,
                    icon: "",
                    right: true,
                    component: <TaskManagement view={"AllTasks"} />,
                },
                ...(isHomeCareCheck === 'true' ? [] : [
                    {
                        name: 'My Tasks',
                        key: 7862,
                        icon: "",
                        right: true,
                        component: <TaskManagement view={"MyTasks"} />,
                    },
                    {
                        name: 'Patient Intake',
                        key: 7863,
                        icon: "",
                        right: true,
                        component: <TaskManagement view={"IntakeTasks"} />,
                    },
                    {
                        name: 'Unsigned Encounters',
                        key: 7864,
                        icon: "",
                        right: true,
                        component: <TaskManagement view={"UnsignedTasks"} />,
                    },
                    {
                        name: 'Pending Superbill/Claims',
                        key: 7865,
                        icon: "",
                        right: true,
                        component: <TaskManagement view={"PendingSuperbills"} />,
                    },]),
            ]
        }
    ]
}

export default MenuList